import { useTenantConfiguration } from '../tenant-configuraiton'

export function useTrainingEnabled() {
  const tenantConfig = useTenantConfiguration()
  return tenantConfig?.trainingEnabled
}
